// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { Variants } from 'framer-motion';

export const menuWrapperVariants: Variants = {
    closed: {
        transition: {
            type: 'tween',
        },
        x: '100vw',
    },
    open: {
        transition: {
            type: 'tween',
        },
        x: 0,
    },
};

export const mobileMenuVariants: Variants = {
    closed: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
    },
    open: {
        transition: { delayChildren: 0.2, staggerChildren: 0.07 },
    },
};
